<template>
  <div class="b-fff ">
    <Search />
    <Table />
  </div>
</template>
<script>
import { systemList } from 'server/modules/ssoApi.js'
import { user_list_get } from 'server/modules/351.js'
import { provide, onMounted, reactive, toRefs } from 'vue'
import Search from './components/Search'
import Table from './components/Table'

export default {
  name: 'personaManage',
  components: {
    Search,
    Table
  },
  setup() {
    const state = reactive({
      departmentId: null,
      creatorId: '',
      userId: '',
      systemId: null,
      roleIds: [],
      systems: [],
      title: null,
      visible: false,
      searchKeyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      roles: [],
      formPerson: {
        names: null,
        title: null,
        roleId: undefined,
        emails: null
      },
      selectedRowKeys: [],
      basicInfo: {},
      setAttrs: (name, value) => {
        state[name] = value
      },
      // 修改页码
      changePage: pageNum => {
        state.pageNum = pageNum
      },
      // 展示弹窗
      showModal: titleValue => {
        state.title = titleValue
        state.visible = true
      },
      // 隐藏弹窗
      handleOk: () => {
        state.visible = false
      },
      // 搜索筛选
      searchKeywordChange: e => {
        state.searchKeyword = e.target.value
      },
      // 初始化字典
      initSystems: async () => {
        const { success, data } = await systemList()
        if (success) {
          const { list } = data
          state.systems = list
          const defaultSystem = list.find(item => {
            return item.systemCode === 'auth'
          })
          state.systemId = defaultSystem.id
        }
      },
      // 获取列表
      initData: async () => {
        // state.tablePagination.current = 1
        const { formPerson, departmentId } = state
        const { pageSize } = state.tablePagination

        const { data } = await user_list_get({
          // systemId: systemId !== -1 ? systemId : null,
          ...formPerson,
          pageNum: state.tablePagination.current,
          pageSize,
          departmentId,
          names: formPerson.names
            ? typeof formPerson.names === 'object'
              ? formPerson.names
              : formPerson.names?.split(',')
            : null,
          emails: formPerson.emails
            ? typeof formPerson.emails === 'object'
              ? formPerson.emails
              : formPerson.emails?.split(',')
            : null
        })
        // state.ids = true
        const { list, total } = data
        state.tablePagination.total = total
        state.list = list
        state.selectedRowKeys = []
      },

      tablePagination: {
        current: 1, //当前页数 v-model
        defaultPageSize: 10,
        defaultCurrent: 1,
        // defaultCurrent: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        showQuickJumper: true, //是否显示直通车
        total: 0, //总数
        local: 'zh',

        pageSizeOptions: ['10', '20', '50', '100', '1000'],
        showSizeChanger: true,
        showLessItems: true,
        onShowSizeChange: (current, pageSize) => {
          state.tablePagination.current = current
          state.tablePagination.pageSize = pageSize
          state.initData()
        },
        onChange: (current, pageSize) => {
          state.tablePagination.current = current
          state.tablePagination.pageSize = pageSize
          state.initData()
        },
        showTotal: total => `共 ${total} 条数据`
      }
    })

    onMounted(() => {
      const { initData } = state
      initData()
    })

    provide('state', state)

    return {
      ...toRefs(state)
    }
  }
}
</script>
